import axios from 'axios';
import { NotificationGetAllQuery } from '../../types';

class NotificationsService {
  getAll = (props: any) => axios.get<NotificationGetAllQuery>(`/notifications`, props);

  read = (id: string) => axios.patch(`/notifications/${id}/read`);

  delete = (id: string) => axios.delete(`/notifications/${id}`);
}

export const notificationsService = new NotificationsService();
